export default {"src":"/_next/static/media/garage-door.521422ae.svg","height":28,"width":29,"blurWidth":0,"blurHeight":0};